/* eslint-disable */ 
import React from 'react'; 
import ContentsList from '../modules/ContentsList';

export default function CaseStudyList(prop) {
    return ( 
        <ContentsList lang={prop.lang} type={prop.type} admin={prop.admin}/>
    ); 
}; 